/**
 * Other Info Section Component
 *
 * その他情報セクション - Additional patient information section
 * Part of the Patient Edit screen (患者編集)
 */

import React from 'react';
import {
  UseFormRegister,
  UseFormWatch,
  UseFormSetValue,
  FieldErrors,
  Controller,
  Control,
} from 'react-hook-form';
import CollapsibleCard from '@/components/molecules/CollapsibleCard';
import { PatientFormSchemaType } from '@pages/main/patient/types';
import { AppTextArea, AppCheckbox, AppForm, AppFormLabel } from '@/components/atoms';

interface OtherInfoSectionProps {
  register: UseFormRegister<PatientFormSchemaType>;
  control: Control<PatientFormSchemaType>;
  watch: UseFormWatch<PatientFormSchemaType>;
  setValue: UseFormSetValue<PatientFormSchemaType>;
  errors: FieldErrors<PatientFormSchemaType>;
  disabled?: boolean;
}

const OtherInfoSection: React.FC<OtherInfoSectionProps> = ({
  control,
  watch,
  setValue,
  errors: _errors,
  disabled = false,
}) => {
  return (
    <CollapsibleCard title="その他">
      <div className="space-y-4" style={disabled ? { pointerEvents: 'none', opacity: 0.6 } : {}}>
        {/* Summary */}
        <div>
          <AppFormLabel label="摘要" />
          <Controller
            name="patient_information.summary"
            control={control}
            render={({ field }) => (
              <AppForm.Item
                className="mb-0"
                validateStatus={_errors.patient_information?.summary ? 'error' : undefined}
                help={(_errors.patient_information?.summary as any)?.message}
              >
                <AppTextArea {...field} rows={3} className="w-full" maxLength={1000} />
              </AppForm.Item>
            )}
          />
        </div>

        {/* Remarks */}
        <div>
          <AppFormLabel label="備考" />
          <Controller
            name="patient_information.remarks"
            control={control}
            render={({ field }) => (
              <AppForm.Item
                className="mb-0"
                validateStatus={_errors.patient_information?.remarks ? 'error' : undefined}
                help={(_errors.patient_information?.remarks as any)?.message}
              >
                <AppTextArea {...field} rows={3} className="w-full" maxLength={1000} />
              </AppForm.Item>
            )}
          />
        </div>

        {/* Checkboxes */}
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <AppCheckbox
            checked={watch('patient_information.is_exclusion')}
            onChange={e => setValue('patient_information.is_exclusion', e.target.checked)}
          >
            除外
          </AppCheckbox>
          <label className="flex items-center gap-2 text-sm">
            <AppCheckbox
              checked={watch('patient_information.is_non_output_telephone')}
              onChange={e =>
                setValue('patient_information.is_non_output_telephone', e.target.checked)
              }
            >
              電話番号を印字しない
            </AppCheckbox>
          </label>
        </div>
      </div>
    </CollapsibleCard>
  );
};

export default OtherInfoSection;
